import _ from "lodash";
import * as PROSPECTS_ACTION_TYPES from "./actionTypes";
import * as PROSPECT_CUSTOMIZE_COLUMNS from "./prospectsCustomizeColumnsActionsTypes";

const INIT_STATE = {
  leads: [],
  error: null,
  loading: false,
  last_page_fetched: 0,
  last_fetched_at: null,
  total_number_of_pages: 0,
  has_next_page: false,
  has_lookahead_pages: false,
  lookahead_pages: 0,
  last_start_date: null,
  last_end_date: null,
  lead_refund_reasons: [],
  customize_columns_error: null,
  customize_columns: null,
  customize_columns_order: null,
  customize_columns_loading: false,
  consent: null,
  consent_loading: false,
  consent_error: null,
  active_request_id: null
}
const Prospects = (state = INIT_STATE, action) => {
  switch (action.type) {
    case PROSPECTS_ACTION_TYPES.GET_PROSPECTS: {
      const { start_date, end_date, page_number } = action.payload.queryParams
      const pageNumber = Number(page_number) || 1
      const appendResults = action.payload?.appendResults === true
      let date_range_changed = false
      if (!(start_date == state.last_start_date && end_date == state.last_end_date)) {
        date_range_changed = true
      }

      return {
        ...state,
        error: null,
        loading: true,
        leads: pageNumber === 1 || !appendResults ? [] : state.leads,
        last_page_fetched: date_range_changed ? 0 : state.last_page_fetched,
        active_request_id: action.payload?.requestId || state.active_request_id,
      }
    }

    case PROSPECTS_ACTION_TYPES.GET_PROSPECTS_SUCCESS: {
      if (action.meta?.requestId && action.meta.requestId !== state.active_request_id) return state
      const additionalData = action.payload.additional_data || {}
      const hasLookaheadPages = Boolean(additionalData.has_lookahead_pages)
      const leads = action.meta?.appendResults === true
        ? _.uniqBy([...state.leads, ...(action.payload.data || [])], 'id')
        : (action.payload.data || [])

      return {
        ...state,
        error: null,
        leads,
        loading: false,
        last_fetched_at: new Date(),
        last_page_fetched: parseInt(additionalData.page_number) || 1,
        last_start_date: additionalData.start_date,
        last_end_date: additionalData.end_date,
        total_number_of_pages: parseInt(additionalData.total_number_of_pages) || 0,
        has_next_page: Boolean(additionalData.has_next_page),
        has_lookahead_pages: hasLookaheadPages,
        lookahead_pages: hasLookaheadPages ? (parseInt(additionalData.lookahead_pages) || 8) : 0,
      }
    }

    case PROSPECTS_ACTION_TYPES.GET_PROSPECTS_ERROR:
      if (action.meta?.requestId && action.meta.requestId !== state.active_request_id) return state
      return {
        ...state,
        error: action.payload,
        loading: false,
        has_next_page: false,
        has_lookahead_pages: false,
        lookahead_pages: 0,

      }

    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_SUCCESS:
      return {
        ...state,
        error: null,
        leads: state.leads.map(lead => lead.id == action.payload.id ? action.payload : lead),
        loading: false,
      }

    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case PROSPECTS_ACTION_TYPES.GET_PROSPECT_BY_ID:
      return {
        ...state,
        error: null,
        loading: true,
      }
    case PROSPECTS_ACTION_TYPES.GET_PROSPECT_BY_ID_SUCCESS:
      const lead_id = action.payload.id
      const lead_index = state.leads.findIndex(lead => lead.id == lead_id)
      let leads = _.cloneDeep(state.leads)
      if (lead_index == -1) {
        leads.push(action.payload)
      } else {
        leads[lead_index] = { ...leads[lead_index], ...action.payload }
      }
      return {
        ...state,
        leads: leads,
        error: null,
        leads: action.payload,
        loading: false
      }
    case PROSPECTS_ACTION_TYPES.GET_PROSPECT_BY_ID_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_DETAILS:
      return {
        ...state,
        error: null,
        loading: true,
      }
    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_DETAILS_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.id === action.payload.lead_id);

        leadToUpdate.lead_detail = { ...leadToUpdate.lead_details, ...action.payload };
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }
    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_DETAILS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case PROSPECTS_ACTION_TYPES.ADD_PROSPECT_VEHICLE:
      return {
        ...state,
        error: null,
        loading: true
      }

    case PROSPECTS_ACTION_TYPES.ADD_PROSPECT_VEHICLE_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.id === action.payload.lead_id);
        leadToUpdate.lead_vehicles.push(action.payload);
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === action.payload.lead_id ? leadToUpdate : lead),
          loading: false,
        }
      }
    case PROSPECTS_ACTION_TYPES.ADD_PROSPECT_VEHICLE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_VEHICLE:
      return {
        ...state,
        error: null,
        loading: true
      }
    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_VEHICLE_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.lead_vehicles.some(vehicle => vehicle.id === action.payload.id));
        const vehicleIndex = leadToUpdate.lead_vehicles.findIndex(vehicle => vehicle.id === action.payload.id);
        leadToUpdate.lead_vehicles[vehicleIndex] = action.payload;
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }

      }
    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_VEHICLE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case PROSPECTS_ACTION_TYPES.DELETE_PROSPECT_VEHICLE:
      return {
        ...state,
        error: null,
      }

    case PROSPECTS_ACTION_TYPES.DELETE_PROSPECT_VEHICLE_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.lead_vehicles.some(vehicle => vehicle.id === action.payload.id));
        const vehicleIndex = leadToUpdate.lead_vehicles.findIndex(vehicle => vehicle.id === action.payload.id);
        leadToUpdate.lead_vehicles.splice(vehicleIndex, 1);
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case PROSPECTS_ACTION_TYPES.ADD_PROSPECT_BUSINESS_ENTITY:
      return {
        ...state,
        error: null,
        loading: true
      }

    case PROSPECTS_ACTION_TYPES.ADD_PROSPECT_BUSINESS_ENTITY_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.id === action.payload.lead_id);
        leadToUpdate.lead_business_entities.push(action.payload);
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case PROSPECTS_ACTION_TYPES.ADD_PROSPECT_BUSINESS_ENTITY_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_BUSINESS_ENTITY:
      return {
        ...state,
        error: null,
        loading: true
      }

    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_BUSINESS_ENTITY_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.lead_business_entities.some(business_entity => business_entity.id === action.payload.id));
        const business_entityIndex = leadToUpdate.lead_business_entities.findIndex(business_entity => business_entity.id === action.payload.id);
        leadToUpdate.lead_business_entities[business_entityIndex] = action.payload;
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_BUSINESS_ENTITY_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case PROSPECTS_ACTION_TYPES.DELETE_PROSPECT_BUSINESS_ENTITY:
      return {
        ...state,
        error: null,
      }

    case PROSPECTS_ACTION_TYPES.DELETE_PROSPECT_BUSINESS_ENTITY_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.lead_business_entities.some(business_entity => business_entity.id === action.payload.id));
        const business_entityIndex = leadToUpdate.lead_business_entities.findIndex(business_entity => business_entity.id === action.payload.id);
        leadToUpdate.lead_business_entities.splice(business_entityIndex, 1);
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case PROSPECTS_ACTION_TYPES.DELETE_PROSPECT_BUSINESS_ENTITY_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case PROSPECTS_ACTION_TYPES.ADD_PROSPECT_VIOLATION:
      return {
        ...state,
        error: null,
        loading: true
      }

    case PROSPECTS_ACTION_TYPES.ADD_PROSPECT_VIOLATION_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.id === action.payload.lead_id);
        leadToUpdate.lead_violations.push(action.payload);
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case PROSPECTS_ACTION_TYPES.ADD_PROSPECT_VIOLATION_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_VIOLATION:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_VIOLATION_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.lead_violations.some(violation => violation.id === action.payload.id));
        const violationIndex = leadToUpdate.lead_violations.findIndex(violation => violation.id === action.payload.id);
        leadToUpdate.lead_violations[violationIndex] = action.payload;
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_VIOLATION_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case PROSPECTS_ACTION_TYPES.DELETE_PROSPECT_VIOLATION:
      return {
        ...state,
        error: null,
        loading: true
      }

    case PROSPECTS_ACTION_TYPES.DELETE_PROSPECT_VIOLATION_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.lead_violations.some(violation => violation.id === action.payload.id));
        const violationIndex = leadToUpdate.lead_violations.findIndex(violation => violation.id === action.payload.id);
        leadToUpdate.lead_violations.splice(violationIndex, 1);
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }

      }

    case PROSPECTS_ACTION_TYPES.DELETE_PROSPECT_VIOLATION_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }


    //Lead Home
    case PROSPECTS_ACTION_TYPES.ADD_PROSPECT_HOME:
      return {
        ...state,
        error: null,
      }

    case PROSPECTS_ACTION_TYPES.ADD_PROSPECT_HOME_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.id === action.payload.lead_id);
        leadToUpdate.lead_homes.push(action.payload);
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case PROSPECTS_ACTION_TYPES.ADD_PROSPECT_HOME_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_HOME:
      return {
        ...state,
        error: null,
        loading: true
      }

    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_HOME_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.lead_homes.some(home => home.id === action.payload.id));
        const homeIndex = leadToUpdate.lead_homes.findIndex(home => home.id === action.payload.id);
        leadToUpdate.lead_homes[homeIndex] = action.payload;
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_HOME_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case PROSPECTS_ACTION_TYPES.DELETE_PROSPECT_HOME:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case PROSPECTS_ACTION_TYPES.DELETE_PROSPECT_HOME_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.lead_homes.some(home => home.id === action.payload.id));
        const homeIndex = leadToUpdate.lead_homes.findIndex(home => home.id === action.payload.id);
        leadToUpdate.lead_homes.splice(homeIndex, 1);
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }

      }

    case PROSPECTS_ACTION_TYPES.DELETE_PROSPECT_HOME_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    //Lear Refund

    case PROSPECTS_ACTION_TYPES.ADD_PROSPECT_REFUND:
      return {
        ...state,
        error: null,
      }

    case PROSPECTS_ACTION_TYPES.ADD_PROSPECT_REFUND_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.id === action?.payload?.lead_id);
        leadToUpdate.lead_refund = action.payload;
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case PROSPECTS_ACTION_TYPES.ADD_PROSPECT_REFUND_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_REFUND:
      return {
        ...state,
        error: null,
        loading: true
      }

    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_REFUND_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.lead_refunds.some(refund => refund.id === action.payload.id));
        leadToUpdate.lead_refund = action.payload;
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }

      }

    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_REFUND_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case PROSPECTS_ACTION_TYPES.DELETE_PROSPECT_REFUND:
      return {
        ...state,
        error: null,
        loading: true
      }

    case PROSPECTS_ACTION_TYPES.DELETE_PROSPECT_REFUND_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.id === action?.payload?.lead_id);
        leadToUpdate.lead_refund = null
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case PROSPECTS_ACTION_TYPES.ADD_PROSPECT_APPLICANT:
      return {
        ...state,
        error: null,
        loading: true
      }

    case PROSPECTS_ACTION_TYPES.ADD_PROSPECT_APPLICANT_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.id === action.payload.lead_id);
        leadToUpdate.lead_applicants.push(action.payload);
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === action.payload.lead_id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case PROSPECTS_ACTION_TYPES.ADD_PROSPECT_APPLICANT_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_APPLICANT:
      return {
        ...state,
        error: null,
        loading: true
      }

    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_APPLICANT_SUCCESS:
      {
        const leadToUpdate = state.leads.find(lead => lead.lead_applicants.some(applicant => applicant.id === action.payload.id));
        const applicantIndex = leadToUpdate.lead_applicants.findIndex(applicant => applicant.id === action.payload.id);
        leadToUpdate.lead_applicants[applicantIndex] = action.payload;
        return {
          ...state,
          error: null,
          leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
          loading: false,
        }
      }

    case PROSPECTS_ACTION_TYPES.UPDATE_PROSPECT_APPLICANT_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case PROSPECTS_ACTION_TYPES.DELETE_PROSPECT_APPLICANT:
      return {
        ...state,
        error: null,
      }

    case PROSPECTS_ACTION_TYPES.DELETE_PROSPECT_APPLICANT_SUCCESS: {
      const leadToUpdate = state.leads.find(lead => lead.lead_applicants.some(applicant => applicant.id === action.payload.id));
      const applicantIndex = leadToUpdate.lead_applicants.findIndex(applicant => applicant.id === action.payload.id);
      leadToUpdate.lead_applicants.splice(applicantIndex, 1);
      return {
        ...state,
        error: null,
        leads: state.leads.map(lead => lead.id === leadToUpdate.id ? leadToUpdate : lead),
        loading: false,
      }
    }

    case PROSPECTS_ACTION_TYPES.DELETE_PROSPECT_APPLICANT_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case PROSPECTS_ACTION_TYPES.GET_PROSPECT_REFUND_REASONS:
      return {
        ...state,
        error: null,
        loading: true
      }

    case PROSPECTS_ACTION_TYPES.GET_PROSPECT_REFUND_REASONS_SUCCESS:
      const new_state = {
        ...state,
        error: null,
        lead_refund_reasons: action.payload,
        loading: false,
      }
      return new_state;

    case PROSPECTS_ACTION_TYPES.GET_PROSPECT_REFUND_REASONS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case PROSPECT_CUSTOMIZE_COLUMNS.GET_PROSPECT_STICKY_COLUMNS:
      return {
        ...state,
        customize_columns_error: null,
        customize_columns_loading: false
      }

    case PROSPECT_CUSTOMIZE_COLUMNS.GET_PROSPECT_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        customize_columns: action.payload,
        customize_columns_loading: false
      }

    case PROSPECT_CUSTOMIZE_COLUMNS.GET_PROSPECT_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        customize_columns_error: action.payload,
        customize_columns_loading: false
      }

    case PROSPECT_CUSTOMIZE_COLUMNS.UPDATE_PROSPECT_STICKY_COLUMNS:
      return {
        ...state,
        customize_columns_loading: true
      }

    case PROSPECT_CUSTOMIZE_COLUMNS.UPDATE_PROSPECT_STICKY_COLUMNS_SUCCESS:
      return {
        ...state,
        customize_columns: action.payload,
        customize_columns_loading: false
      }

    case PROSPECT_CUSTOMIZE_COLUMNS.UPDATE_PROSPECT_STICKY_COLUMNS_ERROR:
      return {
        ...state,
        customize_columns_error: action.payload,
        customize_columns_loading: false
      }

    case PROSPECT_CUSTOMIZE_COLUMNS.GET_PROSPECT_CUSTOMIZE_COLUMNS_ORDER:
      return {
        ...state,
        customize_columns_error: null,
        customize_columns_loading: false
      }

    case PROSPECT_CUSTOMIZE_COLUMNS.GET_PROSPECT_CUSTOMIZE_COLUMNS_ORDER_SUCCESS:
      return {
        ...state,
        customize_columns_order: action.payload,
        customize_columns_loading: false
      }

    case PROSPECT_CUSTOMIZE_COLUMNS.GET_PROSPECT_CUSTOMIZE_COLUMNS_ORDER_ERROR:
      return {
        ...state,
        customize_columns_error: action.payload,
        customize_columns_loading: false
      }

    case PROSPECT_CUSTOMIZE_COLUMNS.UPDATE_PROSPECT_CUSTOMIZE_COLUMNS_ORDER:
      return {
        ...state,
        customize_columns_error: null,
        customize_columns_loading: true
      }

    case PROSPECT_CUSTOMIZE_COLUMNS.UPDATE_PROSPECT_CUSTOMIZE_COLUMNS_ORDER_SUCCESS:
      return {
        ...state,
        customize_columns_order: action.payload,
        customize_columns_loading: false
      }

    case PROSPECT_CUSTOMIZE_COLUMNS.UPDATE_PROSPECT_CUSTOMIZE_COLUMNS_ORDER_ERROR:
      return {
        ...state,
        customize_columns_error: action.payload,
        customize_columns_loading: false
      }
    case PROSPECTS_ACTION_TYPES.GET_CONSENT_INFORMATION_BY_ID:
      return {
        ...state,
        consent_loading: true
      }
    case PROSPECTS_ACTION_TYPES.GET_CONSENT_INFORMATION_BY_ID_SUCCESS:
      return {
        ...state,
        consent_loading: false,
        consent: action.payload
      }
    case PROSPECTS_ACTION_TYPES.GET_CONSENT_INFORMATION_BY_ID_ERROR:
      return {
        ...state,
        consent_error: action.payload,
        consent: null,
        consent_loading: false
      }

    case PROSPECTS_ACTION_TYPES.GET_PROSPECT_DETAILS_EXPORT:
      return {
       ...state,
        error: null,
        loading: true
      }

    case PROSPECTS_ACTION_TYPES.GET_PROSPECT_DETAILS_EXPORT_SUCCESS:
      return {
       ...state,
        error: null,
        loading: false
      }

    case PROSPECTS_ACTION_TYPES.GET_PROSPECT_DETAILS_EXPORT_ERROR:
      return {
       ...state,
        error: action.payload,
        loading: false
      }
    default:
      return state
  }
}

export default Prospects;
